import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Carlos M.',
  location: 'Katy TX',
  text: "I spent months looking for someone reliable. RMorales showed up on time, did an incredible job, and the price was fair. They're my permanent contractors now."
}, {
  name: 'Jennifer R.',
  location: 'Cypress TX',
  text: 'What impressed me most was the cleanliness. Other services mow the grass but leave everything dirty. RMorales left my lawn looking brand new.'
}, {
  name: 'Roberto G.',
  location: 'Richmond TX',
  text: 'My HOA had sent me two notices. I called RMorales on Monday and by Wednesday my lawn was perfect. I never worry about it anymore.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function TestimonialsSection() {
  return <section id="testimonials" className="py-16 md:py-24 bg-white" data-id="element-313">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-314">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-315">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#C5A55A]/10 text-[#C5A55A] mb-6" data-id="element-316">
            <Star className="w-8 h-8 fill-current" data-id="element-317" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2E1B] mb-6" data-id="element-318">
            WHAT THE NEIGHBORS ARE SAYING
          </h2>
          <div className="w-24 h-1 bg-[#C5A55A] mx-auto rounded-full" data-id="element-319"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-320">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-[#f9f7f2] rounded-2xl p-8 relative" data-id="element-321">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#C5A55A]/20" data-id="element-322" />
              <div className="flex gap-1 mb-6" data-id="element-323">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#C5A55A] text-[#C5A55A]" data-id="element-324" />)}
              </div>
              <p className="text-gray-700 italic mb-8 leading-relaxed relative z-10" data-id="element-325">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-326">
                <p className="font-bold text-[#1B2E1B]" data-id="element-327">{testimonial.name}</p>
                <p className="text-sm text-gray-500" data-id="element-328">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}